import Button from '../../Atoms/Button/Button'
import './CampaingAssociateProducts.scss'
import { Table } from 'antd'

const columns = [
  {
    title: "Nombre",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Categoria",
    dataIndex: "category",
    key: "category",
  },
  {
    title: "Descripción",
    dataIndex: "description",
    key: "description",
  },
  {
    title: "Acciones",
    dataIndex: "actions",
    key: "actions",
    fixed: 'right',
  },
];

const CampaingAssociateProducts = () => {

  const productsList = [
    {
      key: 1,
      name: 'Nombre del producto',
      category: 'Servicios',
      description: 'Descripción del producto',
      actions:  <span className="button small primary source-16 s-large m-auto">Editar</span>
    },
    {
      key: 2,
      name: 'Nombre del producto',
      category: 'Servicios',
      description: 'Descripción del producto',
      actions:  <span className="button small primary source-16 s-large m-auto">Editar</span>
    },
    {
      key: 3,
      name: 'Nombre del producto',
      category: 'Servicios',
      description: 'Descripción del producto',
      actions:  <span className="button small primary source-16 s-large m-auto">Editar</span>
    },
  ]

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
    },
  };

  return (
    <div className="box mt-30 s-pxy-20 m-pxy-50">
      <div className="associate-products_header">
        <p className="source-24">Asignación de productos</p>
        <Button content="Asignar/Crear" type="primary" customClass="s-large m-auto" />
      </div>

      <div className="table-container mt-30">
        <Table 
        rowSelection={{
          type: 'checkbox',
          ...rowSelection,
        }} 
        columns={columns} dataSource={productsList} pagination={false} />
      </div>

      <div className="associate-profile-header_buttons">
        <div className="header-buttons_one">
          <Button content="Gestionar campañas" type="primary outline" customClass="s-large m-auto" />
          <Button content="Guardar proceso" type="primary" customClass="s-large m-auto" />
        </div>
        <div className="header-buttons_two">
          <Button content="Guardar y lanzar campaña" type="primary"  customClass="s-large m-auto"/>
        </div>
      </div>
      
    </div>
  )
}

export default CampaingAssociateProducts
